<template>
    <div class="bigdata_container" id="bigdata" v-loading="isLoading" element-loading-text="拼命加载中..."
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            {{ orgName }}数据大屏
        </div>
        <div class="time">{{ currentTime }}</div>
        <div class="quanp">
            <!-- <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
                onFullScreen ? "退出全屏" : "进入全屏"
            }}</el-button> -->
            <img src="../../../assets/img/homecare/screen.png" @click="showFullScreen" class='screen' />
        </div>
        <div class="serach_wrapper">
            <treeselect v-model="regionId" :options="deptOptions" :normalizer="normalizer" :appendToBody="true"
                z-index="9999" placeholder="请选择区域" @select="deptSelect" style="width: 140px; height: 26px" />
            <img src="../../../assets/img/homecare/search.png" @click="handleSearch('search')"
                style="position:absolute;cursor: pointer;width:20px;height:20px;margin-top:3px;margin-left:152px" />
        </div>

        <transition name="nameoftransition">
            <div class="info_tisp" v-show="infoTisp">
                <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
            </div>
        </transition>
        <div class="bigdata_main" v-if="oldIndex === 0">
            <div id="container" style="width: 100%; height: 100%;margin-top:20px"></div>
            <div class="main_left">
                <div class="main_pane main_pane1">
                    <div class="titleHeader">
                        <div class="titleTxt">托养类型</div>
                    </div>
                    <ul class="disabledtype">
                        <li v-for="(v, i) in disList" :key='i' :class="[disIndex === i ? 'active' : '']"
                            @click="disClick(i)">
                            {{ v.label }}</li>
                    </ul>
                    <div id="echartsThree" ref="echartsThree" style="height: 75%; width: 100%;"></div>
                </div>
                <!-- 老人类别统计 -->
                <div class="main_pane main_pane2" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleTxt">本周课程展示</div>
                    </div>
                    <div class="cource">
                        <div class='head'>
                            <ul class='flex'>
                                <li></li>
                                <li style='margin-left:-5px;'>上午</li>
                                <li style='margin-left:-5px;'>下午</li>
                            </ul>
                            <div>
                                <ul class='flex'>
                                    <li class="name">周一</li>
                                    <li class="border">{{ degreeLits.mondayMorning }}</li>
                                    <li class="border">{{ degreeLits.mondayAfternoon }}</li>
                                </ul>
                                <ul class='flex'>
                                    <li class="name">周二</li>
                                    <li class="border">{{ degreeLits.tuesdayMorning }}</li>
                                    <li class="border">{{ degreeLits.tuesdayAfternoon }}</li>
                                </ul>
                                <ul class='flex'>
                                    <li class="name">周三</li>
                                    <li class="border">{{ degreeLits.wednesdayMorning }}</li>
                                    <li class="border">{{ degreeLits.wednesdayAfternoon }}</li>
                                </ul>
                                <ul class='flex'>
                                    <li class="name">周四</li>
                                    <li class="border">{{ degreeLits.thursdayMorning }}</li>
                                    <li class="border">{{ degreeLits.thursdayAfternoon }}</li>
                                </ul>
                                <ul class='flex'>
                                    <li class="name">周五</li>
                                    <li class="border">{{ degreeLits.mondayMorning }}</li>
                                    <li class="border">{{ degreeLits.mondayAfternoon }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main_center">
                <div class="map">
                    <ul class="datatype">
                        <li>
                            <div class="data">{{ typeList1.customerCount }}</div>
                            <span>服务人数</span>
                        </li>
                        <li>
                            <div class="data">{{ typeList1.takeMedicineCount }}</div>
                            <span>当日服药人数</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="main_right">
                <!-- 本周菜单展示 -->
                <div class="main_pane main_pane4">
                    <div class="titleHeader">
                        <div class="titleTxt">本周菜单展示</div>
                    </div>
                    <div class="caidan">
                        <ul class="week">
                            <li v-for="(v, i) in weekList" :key='i' :class="[weekIndex === i ? 'active' : '']"
                                @click="weekClick(i)">{{ v.name }}</li>
                        </ul>
                        <div class="meal">
                            <div class="name">早餐</div>
                            <div class="type">
                                {{ weekForm.morning }}
                            </div>
                        </div>
                        <div class="meal">
                            <div class="name">中餐</div>
                            <div class="type">
                                {{ weekForm.afternoon }}
                            </div>
                        </div>
                        <div class="meal">
                            <div class="name">晚餐</div>
                            <div class="type">
                                {{ weekForm.evering }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 服务工单类型 -->
                <div class="main_pane main_pane5" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleTxt">人员风采</div>
                        <ul class="ctype">
                            <li v-for="(v, i) in ctypeList" :class="[i == typeIndex ? 'cactive' : '', 'item']"
                                @click="typeClick(i, v)">{{ v.name
                                }}
                            </li>
                        </ul>
                    </div>
                    <div class="fourpart">
                        <div class="item" v-for="(v, i) in speciList" :key="i">
                            <img :src="v.url" class="img" />
                            <p class="title">姓名: {{ v.name }}</p>
                            <p class="cont">联系方式: {{ v.phone }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="infotitle" :visible.sync="dialogVisible" width="30%" custom-class="speinfo"
            style='margin-top:28vh;' :before-close="handleClose">
            <div class="top">
                <div class="left">
                    <img :src="infoData.personPhoto" class='img' />
                    <div class="info">
                        <p v-if="typeValue == 2">站点名称：{{ infoData.statName }}</p>
                        <p v-else>姓名：{{ infoData.personName }}</p>
                        <p>联系方式：{{ infoData.personPhone }}</p>
                        <p class="add"><span class="first">地址：</span><span>{{ infoData.address }}</span></p>
                    </div>
                </div>
                <!-- <div class="right" @click="showVideo">视频通话</div> -->
            </div>
        </el-dialog>
        <!-- 弹窗 end -->
        <shipingtonghua v-if="videoModal" :userId="userinfo.id" :mobilePhone='userinfo.personPhone'
            :closeSP.sync="videoModal"></shipingtonghua>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import * as echarts from "echarts"
import shipingtonghua from "@/components/shipingtonghua.vue"
export default {
    name: "visualized",
    components: {
        shipingtonghua,
    },
    data() {
        return {
            currentTime: '',
            timeC: null,
            infoTisp: false,
            isLoading: false,
            keyword: "", //搜索
            onFullScreen: false, // 是否全屏
            echartThree: null, // 改造产品统计echarts
            map: null, //地图实例
            markers: [], //地图标记点
            dialogVisible: false,
            stepIndex: 1,
            dialogTitle: "",
            formData: {
                name: "",
                sex: "",
                age: "",
                idCode: "",
                phone: "",
                olderType: "",
            },
            nameList: [],
            typeList1: {}, //托养类型
            typeForm: [],
            degreeLits: {},
            totallist: {},
            comList: [],
            stateList: [],
            dayList: [],
            speciList: [],
            cid: '',
            orgList: [],
            stationData: [],
            userinfo: {},
            videoModal: false,
            infoData: {},
            typeValue: null,
            regionId: '',
            regionName: '',
            polygons: [],
            deptOptions: [],
            oldIndex: 0,
            infotitle: '',
            orgName: '',
            disList: [
                { label: '男女比例', value: 0 },
                { label: '年龄分布', value: 1 },
                { label: '出勤比例', value: 2 }
            ],
            disIndex: 0,
            weekList: [
                { name: '周一' },
                { name: '周二' },
                { name: '周三' },
                { name: '周四' },
                { name: '周五' }
            ],
            wform: {},
            weekForm: {},
            weekIndex: 0,
            courceType: 1,//1老师 2学员
            ctypeList: [{
                name: '老师',
                value: 1
            }, {
                name: '学员',
                value: 2
            }],
            typeIndex: 0,
            echartO:null,
        }
    },
    async created() {
        this.orgName = this.$store.state.info.orgName
        this.regionId = this.$store.state.info.orgId
        this.cid = this.regionId

    },
    async mounted() {
        let self = this
        await self.loadMap()
        window.addEventListener("resize", () => {
            // 自适应所有echarts
            const handleResize = () => {
                if (!checkFull()) {
                    self.onFullScreen = false
                }
            }
            window.onresize = handleResize
            function checkFull() {
                let isFull =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement
                if (isFull === undefined) isFull = false
                return isFull
            }
            self.$nextTick(() => {
                self.echartO && self.echartO.resize() // 
            })
        })
        this.init()
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    beforeDestroy() {
        // 组件销毁前清除定时器  
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    _methods: {
        //获取组织
        listDept() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/getUserOrgTree",
                    method: "POST",
                    data: {
                    },
                })
                .then((res) => {
                    console.log(res, 'res')
                    if (res.code === 200) {
                        if (res.content != null) {
                            let arr = [res.content]
                            this.deptOptions = this.handleTree(arr, "deptId");
                        }
                    }
                })
        },
        /** 转换机构数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.orgId,
                label: node.label,
                children: node.children,
            };
        },
        deptSelect(item) {
            this.orgName = item.label
        },
        // 获取时间
        getTime() {
            let yy = new Date().getFullYear()
            let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1
            let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()
            let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds()
            this.currentTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
        },
        currentTime1() {
            setInterval(this.getTime, 500)
        },
        //托养类型切换
        disClick(i) {
            this.disIndex=i
            if (i == 0) {
                this.typeForm = {
                    男性: this.typeList1.maleCount,
                    女性: this.typeList1.femaleCount
                }
            }else if(i===1){
                this.typeForm = {
                    '20岁以下': this.typeList1.underTwentyCount,
                    '20-30岁': this.typeList1.twentyThirtyCount,
                    '30-40岁': this.typeList1.thirtyFortyCount,
                    '40-50岁': this.typeList1.fortyFiftyCount,
                    '50-60岁': this.typeList1.fortyFiftyCount,
                    '60-70岁': this.typeList1.sixtySeventyCount,
                    '大于70岁': this.typeList1.overSeventyCount,
                }
            }else{
                this.typeForm ={
                  未出勤:this.typeList1.absentCount,
                  已出勤:this.typeList1.attendanceCount
                }
            }
            this.echartsThree(this.typeForm)
        },
        //托养类型
        getOneList() {
            this.$http
                .request({
                    url: "/jjyl/admin/tyzx/bigScreen/info/findCenterCountStat",
                    method: "POST",
                    data: {
                        id: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.typeList1 = res.content
                            this.typeForm = {
                                男性: this.typeList1.maleCount,
                                女性: this.typeList1.femaleCount
                            }
                            this.echartsThree(this.typeForm)
                        }
                    }
                })
        },
        echartsThree(nameList) {
            let arraylist = this.getArray(nameList)
            let nameD = []
            var istotal=0
            arraylist.forEach((item) => {
                nameD.push(item.name)
                istotal+=item.value
            })
           if(istotal===0){
            return false
           }
            var chartDom = document.getElementById("echartsThree")
            var myChart = echarts.init(chartDom)
            this.echartO=myChart
            var option
            let value = '比例'
            var img = ''
            var trafficWay = arraylist
            var data = [];
            var color = ['#00ffff', '#00cfff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000']
            for (var i = 0; i < trafficWay.length; i++) {
                data.push({
                    value: trafficWay[i].value,
                    name: trafficWay[i].name,
                    itemStyle: {
                        normal: {
                            borderWidth: 5,
                            shadowBlur: 20,
                            borderColor: color[i],
                            shadowColor: color[i]
                        }
                    }
                }, {
                    value: 2,
                    name: '',
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            color: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 0
                        }
                    }
                });
            }
            var seriesOption = [{
                name: '',
                type: 'pie',
                clockWise: false,
                radius: ['30%', '35%'],
                center: ['48%', '40%'],
                hoverAnimation: false,
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#ddd',
                            formatter: function (params) {
                                var percent = 0;
                                var total = 0;
                                for (var i = 0; i < trafficWay.length; i++) {
                                    total += trafficWay[i].value;
                                }
                                if (total === 0) {
                                      return ''; // 当没有有效数据时，返回空
                                 }
                                if(params.value===0){
                                    percent=0 
                                }else{
                                    percent = ((params.value / total) * 100).toFixed(0);
                                }
                                if (params.name !== '') {
                                    return + percent + '%';
                                } else {
                                    return '';
                                }
                            },
                        },
                        labelLine: {
                            length: 10,
                            length2: 20,
                            show: true,
                            color: '#8CFFF4'
                        }
                    }
                },
                data: data
            }];
            option = {
                backgroundColor: 'transparent',
                color: color,
                title: {
                    text: '比例',
                    top: '34.5%',
                    textAlign: "center",
                    left: "46%",
                    textStyle: {
                        color: '#C9C9C9',
                        fontSize: 16,
                        fontWeight: '400'
                    }
                },
                grid: {
                    top: '3%',
                    bottom: '3%'
                },
                graphic: {
                    elements: [{
                        type: "image",
                        z: 3,
                        style: {
                            image: img,
                            width: 178,
                            height: 178
                        },
                        left: 'center',
                        top: 'center',
                        position: [100, 100]
                    }]
                },
                tooltip: {
                    show: false
                },
                legend: {
                    orient: 'horizontal',
                    // x: 'left',
                    data: nameD,
                    bottom: '6%',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10
                    },
                    itemWidth: 14,
                    itemHeight: 14
                },
                toolbox: {
                    show: false
                },
                series: seriesOption
            }
            option && this.echartO.setOption(option)
        },
        // 本科课程展示
        getTwoList() {
            this.$http
                .request({
                    url: "/jjyl/admin/buWeekCourse/info/findList",
                    method: "POST",
                    data: {
                        orgId: this.cid,
                        type: this.courceType
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.degreeLits = res.content[0]
                        }
                    }
                })
        },
        //本周菜单
        getThreeList() {
            this.$http
                .request({
                    url: "/jjyl/admin/buWeekFood/info/findList",
                    method: "POST",
                    data: {
                        orgId: this.cid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.wform = res.content[0]
                            this.weekForm.morning = this.wform.mondayBreakfast
                            this.weekForm.afternoon = this.wform.mondayLunch
                            this.weekForm.evering = this.wform.mondayDinner
                        }
                    }
                })
        },
        weekClick(i) {
            this.weekIndex = i
            if (i == 0) {
                this.weekForm.morning = this.wform.mondayBreakfast
                this.weekForm.afternoon = this.wform.mondayLunch
                this.weekForm.evering = this.wform.mondayDinner
            } else if (i === 1) {
                this.weekForm.morning = this.wform.tuesdayBreakfast
                this.weekForm.afternoon = this.wform.tuesdayLunch
                this.weekForm.evering = this.wform.tuesdayDinner
            } else if (i === 2) {
                this.weekForm.morning = this.wform.wednesdayBreakfast
                this.weekForm.afternoon = this.wform.wednesdayLunch
                this.weekForm.evering = this.wform.wednesdayDinner
            } else if (i === 3) {
                this.weekForm.morning = this.wform.thursdayBreakfast
                this.weekForm.afternoon = this.wform.thursdayLunch
                this.weekForm.evering = this.wform.thursdayDinner
            } else if (i === 4) {
                this.weekForm.morning = this.wform.fridayBreakfast
                this.weekForm.afternoon = this.wform.fridayLunch
                this.weekForm.evering = this.wform.fridayDinner
            } else if (i === 5) {
                this.weekForm.morning = this.wform.saturdayBreakfast
                this.weekForm.afternoon = this.wform.saturdayLunch
                this.weekForm.evering = this.wform.saturdayDinner
            } else {
                this.weekForm.morning = this.wform.sundayBreakfast
                this.weekForm.afternoon = this.wform.sundayLunch
                this.weekForm.evering = this.wform.sundayDinner
            }
        },
        typeClick(i, v) {
            this.typeIndex = i
            this.courceType = v.value
            this.getSpeList()
        },
        //人员风采
        getSpeList() {
            this.$http
                .request({
                    url: "/jjyl/admin/buTeacherStudentCharacteristic/info/findList",
                    method: "POST",
                    data: {
                        orgId: this.cid,
                        type: this.courceType
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            if (res.content.length > 6) {
                                this.speciList = res.content
                            } else {
                                this.speciList = res.content.slice(0, 6)
                            }
                        }
                    }
                })
        },
        getArray(disabilityData) {
            const data = [];
            // 遍历对象并收集数据  
            for (const key in disabilityData) {
                if (disabilityData.hasOwnProperty(key)) {
                    data.push({
                        name: key,
                        value: disabilityData[key]
                    });
                }
            }
            return data
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        formatDate(dateStr) {
            // 将日期字符串从 'YYYY-MM-DD' 格式转换为 'MM.DD' 格式  
            const [year, month, day] = dateStr.split('-').map(Number);
            return `${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}`;
        },

        handleClose() {
            this.dialogVisible = false
        },
        showVideo() {
            this.userinfo = this.infoData
            this.videoModal = true
        },
        //获取服务站打点
        getStation() {
            this.$http
                .request({
                    url: "/ypt/admin/serviceStation/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 10000,
                        dataId: this.cid,
                        type: 698
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.stationData = res.content.list || []
                            let data = this.stationData.filter(
                                (item) => item.addressLng && item.addressLat
                            )
                            data.forEach((item) => {
                                item.longitude = item.addressLng
                                item.latitude = item.addressLat
                            })
                            this.renderMapMarker(data, 2)
                        }
                    }
                })
        },
        handleSearch(sign = "", id = "") {
            let self = this
            self.map.remove(this.markers)
            self.markers = []
            self.cid = self.regionId
            self.loadMap()
            self.getOneList()  //托养
            self.getTwoList()  //本周课程
            self.getThreeList()
            self.getSpeList()
            //定位打点
             this.getStation()
        },
        renderMapMarker(data, value) {
            var image = null
            if (value === 1) {
                image = require("@/assets/img/map/map-person1.png")
            } else if (value === 2) {
                image = require("@/assets/img/map/serviceStation.png")
            } else {
                image = require("@/assets/img/map/map-person2.png")
            }
            let self = this
            var endIcon = new AMap.Icon({
                size: new AMap.Size(40, 47),
                image: image,
                imageSize: new AMap.Size(32, 36),
            })
            data.forEach((item) => {
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: endIcon,
                })

                self.markers.push(marker)
                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    self.dialogVisible = true
                    this.typeValue = value
                    if (value === 1) {
                        self.getStaffById(item.id)
                        self.infotitle = '服务人员基本信息'
                    } else if (value === 2) {
                        this.infoData = item //
                        this.infotitle = '服务站点基本信息'
                        this.infoData.personPhone = item.phone
                        this.infoData.personPhoto = item.photo
                    }
                })
            })
            self.map.add(self.markers)
            // self.map.add(self.polygon)
            self.map.setFitView(self.polygon) //视口自适应
        },
        getStaffById(id) {
            this.$http
                .request({
                    url: "/jjyl//admin/serviceStaffCustomerCenter/info/getServerPersonById",
                    method: "POST",
                    data: {
                        id: id,
                        orgType: 499
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        this.infoData = res.content.serviceStaff
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        //循环遍历地址
        async loopAddress() { },
        async init() {
            await Promise.all([
                this.listDept(),
                this.currentTime1(),
                this.getOneList(),
                this.getTwoList(),
                this.getThreeList(),
                this.getSpeList(),
            ]);
            this.$nextTick(() => {
                setTimeout(async () => {
                    //太慢了 先去掉
                    await this.getStation()
                }, 550)
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.map = new AMap.Map("container", {
                        resizeEnable: true,
                        _mapStyle: "amap://styles/darkblue",
                        get mapStyle() {
                            return this._mapStyle
                        },
                        set mapStyle(value) {
                            this._mapStyle = value
                        },
                        zoom: 8,
                    })
                    this.areaBG(this.map, this.orgName)
                    this.map.setZoom(8)
                    // this.map.setCenter([119.015372,33.61037])
                    resolve()
                }, 300)
            })
        },
        areaBG(map, cityName) {
            let vm = this
            if (vm.polygons && vm.polygons.length > 0) {
                vm.polygons.forEach(polygon => {
                    vm.map.remove(polygon); // 从地图上移除多边形
                });
                vm.polygons = []; // 清空存储多边形的数组
            }
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                console.log(cityName, 'cityName')
                district.search(`${cityName}`, function (status, result) {
                    console.log(result, 'result')
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            vm.polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 3,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0].districtList)
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
    beforeDestory() {
        window.removeEventListener("resize")
    },
}
</script>
<style>
html,
body {
    overflow: hidden;
}
</style>
<style lang="less" scoped>
html{
    font-size:20px;
}
/deep/.vue-treeselect__control {
    background: transparent !important;
    border: 1px solid #57EAE7 !important;
}

/deep/.vue-treeselect__single-value,
/deep/.vue-treeselect__placeholder {
    color: #fff !important;
    font-size: 13px;
    line-height: 26px !important
}

/deep/.vue-treeselect__control {
    height: 26px !important;
}

/deep/.vue-treeselect__menu {
    display: block !important;
    z-index: 9999;
}

/deep/.el-carousel {
    width: 100%;
    height: 100%;
}

.small {
    color: #fff;
    font-size: 16px;
    text-align: center;
    padding-top: 15px;
}
/deep/.el-dialog__headerbtn {
                top: 13px;
            }
/deep/.speinfo {
    background: #2D497D;
    border: 1px solid #91CDFF;

    .el-dialog__header {
        padding: 5px 6px;
        margin: 8px 9px;
        background: #6181BC;
        border: 1px solid #91CDFF;

        .el-dialog__title,
        .el-dialog__close {
            font-size: 13px;
            color: #fff;

           
        }
    }

    .img {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border-radius: 4px;
        margin-right: 10px;
    }

    .top {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;
        }

        .right {
            width: 132px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #91CDFF;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
            color: #fff;
            font-size: 12px;
        }

        .add {
            display: flex;

            .first {
                white-space: nowrap;
            }
        }
    }

    .el-dialog__body {
        padding: 11px 16px;
    }
}

.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}

.nameoftransition-enter,
.nameoftransition-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

//引入的字体样式
// @font-face {
//     font-family: "Unidtrsmled";
//    // src: url(../assets/font/UnidreamLED.ttf);
// }
.bigdata_container {
    * {
        box-sizing: content-box;
    }
}

/deep/ .el-carousel__container {
    height: 100% !important;

    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
        color: #489aff;
        font-weight: bold;
        font-size: 22px;
    }
}


/deep/ .serach_wrapper {
    z-index: 100;
    position: absolute;
    right: 5%;
    top: 30px;
    transform: translateX(-50%);
    display: flex;

    .el-button {
        color: #0291c2;
        background: #041d4d;
        border: none;
    }

    .el-button--small {
        padding: 5px 6px;
    }

    .el-input__inner {
        color: #0291c2;
        background: #102132;
        border-color: #233b87;
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../../../assets/img/homecare/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .info_tisp {
        min-width: 380px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: #ebeef5;
        position: fixed;
        left: 50%;
        top: 20px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        background-color: #edf2fc;
        border-radius: 5px;
        -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s,
            -webkit-transform 0.4s;
        padding: 15px;
        display: flex;
        align-items: center;
        line-height: 1;

        .el-message__icon {
            margin-right: 10px;
        }
    }

    .header {
        margin: auto;
        width: 100%;
        height: 77px;
        background: url("../../../assets/img/homecare/topbg.png") no-repeat center center;
        background-size: 100%;
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 30px;
    }

    .bigdata_main {
        position: absolute;
        left: 0;
        top: 50px;
        right: 0;
        bottom: 0;

        .main_pane {
            // background: linear-gradient( 180deg, rgba(35,58,100,0) 0%, #233A64 100%);
            background: #1B3054;
            height: 44vh;
            position: relative;
            z-index: 999;
        }

        .main_left {
            position: absolute;
            top: 4%;
            bottom: 0%;
            left: 1%;
            width: 20%;
            overflow-y: auto;

            .main_pane1 {
                .titleBox {
                    height: 170px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                        height: 0 !important;
                    }
                }
            }

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_center {
            position: absolute;
            top: 3%;
            // bottom: 5%;
            right: 20.5%;
            left: 20.5%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .main_right {
            position: absolute;
            top: 4%;
            bottom: 0%;
            right: 1%;
            width: 20%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }

        .titleHeader {
            background: url("../../../assets/img/homecare/part.png") no-repeat;
            background-size: 100%;
            height: 6vh;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .tititleTxttleIcon {
                display: inline-block;
                height: 5.4vh;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 16px;
                line-height: 4.1vh;
                color: #fff;
                margin-left: 10%;
                white-space:nowrap;
            }
        }

        .iconimg {
            // background: url("../assets/img/title-icon.png") no-repeat center
            //     center;
            background-size: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .titleIcon {
                display: inline-block;
                height: 37px;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 16px;
                line-height: 37px;
                color: #569cea;
            }
        }

        .titleBox {
            width: 100%;
            padding: 0 12px;
            box-sizing: border-box;
            border: 1px solid #1b3074;

            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                li {
                    margin-top: 20px;
                    width: 25%;
                    color: #ffffff;
                    text-align: center;
                    line-height: 1;

                    .bgimg {
                        font-family: Unidtrsmled;
                        font-size: 16px;
                        // background: url("../assets/img/9.png") no-repeat center
                        //     center;
                        background-size: 100%;
                        display: inline-block;
                        border-radius: 5px;
                        color: #02e0e4;
                        width: 70%;
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }

                    p {
                        font-family: "Unidtrsmled";
                        margin-top: 6px;
                        font-size: 12px;
                    }
                }
            }

            .li {
                padding-left: 4px;
                font-size: 14px;
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                color: #fff;
                line-height: 24px;

                .img {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    font-family: Unidtrsmled;
                }

                .txt {
                    margin-left: 20px;
                    width: 52%;
                    overflow: hidden;
                    height: 18px;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    text-align: center;
                }

                .time {
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                }
            }
        }

        .flex1 {
            display: flex;
            flex-direction: column;
        }

        .datatype {
            display: flex;

            li {
                margin-right: 24px;

                .data {
                    height: 30px;
                    line-height: 30px;
                    font-size: 18px;
                    color: #fff;
                    padding: 0 20px;
                    min-width: 80px;
                    margin-bottom: 6px;
                    font-weight: bold;
                    background: linear-gradient(90deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%)
                }

                .unit {
                    font-size: 12px;
                }

                span {
                    color: #fff;
                    font-size: 14px;
                }
            }
        }

        .map {
            position: relative;
            margin-top: 30px;
            text-align: center;
            color: #4ac3ff;
            // height: 100%;
            padding: 0 24px;
            //   background: url("../assets/img/tc.png") no-repeat center center;
            // background-size: 100% 100%;

            .title_wrap {
                position: absolute;
                top: -0%;
                left: 50%;
                font-weight: bold;
                transform: translateX(-50%);
            }

            &:nth-child(1) {
                position: relative;
                top: -10px;
                position: relative;
                padding: 30px 3px 5px;
                box-sizing: border-box;
                overflow: hidden;

                .map_wrapper {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    // background: url("../assets/img/tc.png") no-repeat center
                    //     center;
                    background-size: 100% 100%;
                }
            }

            &:nth-child(1) {
                margin-top: 4px;
            }
        }
    }

    .time {
        font-size: 14px;
        color: #fff;
        top: 37px;
        position: absolute;
        left: 20px;
    }

    .quanp {
        width: 20px;
        height: 20px;
        float: right;
        position: absolute;
        top: 31px;
        right: 28px;
        z-index: 999;

        .screen {
            width: 100%;
            height: 100%
        }
    }
}

.disabledtype {
    display: flex;
    justify-content: space-between;
    margin:1.2vh 4.5% 0;

    li {
        font-size: 14px;
        color: #C9C9C9;
        height: 5vh;
        line-height: 5vh;
        padding: 0 12px;
        cursor: pointer;
        white-space:nowrap;
    }

    .active {
        background: linear-gradient(180deg, rgba(55, 103, 236, 0) 0%, #7AC2FF 78%, rgba(122, 194, 255, 0) 100%);
        opacity: 0.78;
        color: #8CFFF6;
        text-align: center;
    }
}

// 弹框步骤条样式
/deep/ #el-step {
    margin-bottom: 30px;

    .el-step__icon.is-text {
        border-radius: 5px;
    }

    .is-finish .el-step__icon {
        background: #409eff;
    }

    .el-step__icon {
        width: auto;
        padding: 22px 38px;
        color: #ffffff;
        cursor: pointer;
        border: none;
        background: #c0c4cc;
    }

    .el-step {
        height: 40px;
        margin-bottom: 24px;
    }

    .el-step.is-horizontal .el-step__line {
        top: 20px;
    }
}

.check_form_item {
    img {
        width: 100px;
        height: 100px;
    }
}

.el-step.is-center /deep/.el-step__line {
    right: -27%;
    left: 73%;
    border-top: 1px solid #c8b226;
    background-color: transparent;
}

/deep/ .check_form_item,
/deep/ .acceptance_form_item {
    display: flex;
    flex-direction: column;

    .el-form-item__label {
        width: 100% !important;
        margin-bottom: 12px;
        text-align: left;
        border-bottom: 1px solid #c0c4cc;
    }

    /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
}

.photo {
    font-size: 0;

    img {
        width: 160px;
        height: 160px;
    }
}

/deep/.el-dialog {
    background: #092267;
    opacity: 0.8;
}

#el-step /deep/.el-step__icon {
    background: none;
    color: #c8b226;
    border: 1px solid #c8b226;
}

#el-step /deep/.is-finish .el-step__icon {
    background: #c8b226;
    color: #fff;
}

/deep/.dialog_container .el-dialog__footer {
    background: #092267;
    border-top: none;
    opacity: 0.8;
    text-align: center;

    .el-button {
        border: 1px solid #4a93dc;
        color: #fff;
        margin-bottom: 8px;
        background: #092267;
    }

    .el-button:hover {
        background: #092267;
    }
}

/deep/.el-form-item__label {
    color: #fff;
}

.el-input.is-disabled /deep/.el-input__inner {
    background-color: #85b6db;
    color: #fff;
    opacity: 0.55;
    border: none;
}

.el-textarea.is-disabled /deep/.el-textarea__inner {
    background-color: #85b6db;
    color: #fff;
    border: none;
    opacity: 0.55;
}

/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

/deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}

.cource {
    margin:0 12px;
    height:38vh;
    .head{
        height:100%;
    }
    .flex {
        display: flex;
        margin-bottom: 12px;
        justify-content: space-between;
        margin: 0 20px;
        align-items: center;

        li {
            width: 25%;
            text-align: center;
            color: #D9E2F1;
            font-size: 18px;
            margin-top: 1.5vh;
        }

        li:nth-child(2) {
            margin-left: 10px;
            margin-right: 10px;
        }

        .name {
            color: #D9E2F1;
            font-size: 16px;
            white-space:nowrap;
        }

        .border {
            background: rgba(95, 134, 199, 0.16);
            border: 1px solid #83B0FF;
            width: 143px;
            height: 4.5vh;
            line-height: 4.5vh;
            color: #8CD0FF;
        }
    }
}

.caidan {
    margin: 1vh  12px 0;
}

.week {
    display: flex;
    justify-content: space-between;
    height: 4.2vh;
    line-height: 4.2vh;
    background: linear-gradient(180deg, rgba(174, 223, 253, 0) 0%, rgba(118, 187, 249, 0.27) 36%, rgba(118, 187, 249, 0.33) 64%, rgba(118, 187, 249, 0) 100%);
    color: #A0BADE;
    padding: 0 10px;

    li {
        font-size: 14px;
    }

    .active {
        color: #fff;
    }
}

.meal {
    display: flex;
    margin-bottom: 12px;
    width: 98%;
    align-items: center;
    margin-top: 1.2vh;

    .name {
        color: #fff;
        font-size: 18px;
        width: 27px;
        height: 8vh;
        font-size: 14px;
        color: #8CD0FF;
        white-space: wrap;
        background: linear-gradient(270deg, rgba(140, 208, 255, 0.44) 0%, rgba(140, 208, 255, 0) 100%);
        display: flex;
        align-items: center;
        text-align: center;
    }

    .type {
        background: rgba(140, 208, 255, 0.17);
        border: 1px solid #8CD0FF;
        height: 8.7vh;
        margin-left: 10px;
        width: calc(100% - 27px);
        display: flex;
        align-items: center;
        color: #f8f8f8;
        font-size: 13px;
        padding-left: 15px;
    }
}

.fourpart {
    display: flex;
    flex-wrap: wrap;
    margin: 1.2vh 14px 0;

    .item {
        width: 31.2%;
        border: 1px solid #70A3FF;
        margin-right: 2%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 12px;

        .img {
            width: 100%;
            height: 8.8vh;
            margin-bottom: 10px;
            margin: 0 8px;
        }

        .title {
            font-size: 11px;
            color: #8CD0FF;
            margin: 10px 0;
            text-align: left;
            width: 80%;
        }

        .cont {
            font-size: 11px;
            color: #8CD0FF;
            width: 80%;
            margin-bottom: 10px;
        }
    }

    .item:nth-child(3n) {
        margin-right: 0
    }
}

.ctype {
    display: flex;
    margin-top: 5%;
    margin-left: 15%;

    li {
        font-size: 14px;
        color: #999;
        margin-right: 20px;
    }

    .cactive {
        color: #fff;
    }
}
</style>
